import React from 'react'

const WorkingProcess = () => {
    return (
        <>
            <section className="how_it_work pt_120 xs_pt_100 pb_120 xs_pb_100" style={{ background: 'url(assets/images/how_it_work_bg.jpg)', marginTop:"-40px" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-7 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="section_heading mb_25" style={{marginTop:"-60px"}}>
                                <h5>how to work</h5>
                                <h2>Our Working Process</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="simply_work_single">
                                <div className="icon">
                                    <img src="assets/images/simply_work_icon.svg" alt="Work" className="img-fluid" />
                                </div>
                                <h3>Experienced & Professional Team</h3>
                                
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="simply_work_single active">
                                <div className="icon">
                                    <img src="assets/images/simply_work_icon.svg" alt="Work" className="img-fluid" />
                                </div>
                                <h3>Quality Assurance at Every Step</h3>
                               
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="simply_work_single">
                                <div className="icon">
                                    <img src="assets/images/simply_work_icon.svg" alt="Work" className="img-fluid" />
                                </div>
                                <h3>On-Time Project Delivery</h3>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default WorkingProcess
